module.exports = __webpack_public_path__ + "static/varre2-cac3d68895d395df16e28ba95441deb2.jpg";